export const isVtiVehicle = (dataSource?: string) => dataSource === 'GWC_D2C';
